<div
  class="min-h-screen bg-[#F3F4F6] text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300"
>
  <!-- Header (โครงเดียวกับ parking-cards) -->
  <div
    class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4"
  >
    <div>
      <h1
        class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight"
      >
        บัตรที่ยกเลิกแล้ว
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ดูรายการบัตรจอดรถที่ยกเลิกแล้ว
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button
        type="button"
        (click)="onRefresh()"
        class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center"
        title="รีเฟรชข้อมูล"
      >
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <!-- Table card -->
  <div
    class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
    style="animation-delay: 0.2s"
  >
    <div
      class="p-4 sm:p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col gap-4"
    >
      <h3
        class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2 shrink-0 whitespace-nowrap"
      >
        <span class="material-icons text-rose-500 shrink-0">delete_forever</span>
        รายการบัตรที่ยกเลิก
      </h3>

      <div class="flex flex-col gap-3 w-full min-w-0">
        <div
          class="flex flex-col lg:flex-row gap-3 w-full min-w-0 lg:items-center"
        >
          <div
            class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-visible w-full min-w-0 flex-1 relative z-30 h-[46px]"
          >
            <!-- Search Type Dropdown -->
            <div
              class="relative w-[110px] sm:min-w-[130px] sm:w-auto shrink-0 border-r border-slate-200 dark:border-slate-700 h-full"
            >
              <button
                type="button"
                (click)="toggleSearchTypeDropdown()"
                class="w-full h-full pl-3 sm:pl-4 pr-2 sm:pr-3 text-sm font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between gap-1 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-l-xl transition-all focus:outline-none"
              >
                <span class="truncate">{{ currentSearchTypeLabel }}</span>
                <span
                  class="material-icons text-sm text-slate-400 dark:text-slate-500 transition-transform duration-200 shrink-0"
                  [ngClass]="{ 'rotate-180': isSearchTypeDropdownOpen }"
                  >expand_more</span
                >
              </button>

              <button
                *ngIf="isSearchTypeDropdownOpen"
                type="button"
                class="fixed inset-0 cursor-default z-50"
                (click)="toggleSearchTypeDropdown()"
              ></button>

              <div
                *ngIf="isSearchTypeDropdownOpen"
                class="absolute top-full mt-2 left-0 w-[180px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden animate-fade-in-up"
              >
                <button
                  type="button"
                  (click)="selectSearchType('license')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >directions_car</span
                  >
                  ทะเบียนรถ
                </button>
                <button
                  type="button"
                  (click)="selectSearchType('name')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >label</span
                  >
                  ชื่อลูกค้า
                </button>
                <button
                  type="button"
                  (click)="selectSearchType('card_name')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >badge</span
                  >
                  หมายเลขบัตร
                </button>
                <button
                  type="button"
                  (click)="selectSearchType('card_code')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >pin</span
                  >
                  รหัสระบบ
                </button>
                <button
                  type="button"
                  (click)="selectSearchType('uid')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >vpn_key</span
                  >
                  UID
                </button>
              </div>
            </div>

            <!-- Search Input -->
            <div class="relative flex-1 flex w-full min-w-0 h-full">
              <span
                class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 dark:text-slate-500 text-xl pointer-events-none"
                >search</span
              >
              <input
                type="text"
                placeholder="ค้นหา..."
                [(ngModel)]="searchText"
                (keyup.enter)="onSearch()"
                class="w-full flex-1 min-w-0 pl-10 pr-2 h-full bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600"
              />
              <button
                type="button"
                (click)="onSearch()"
                class="px-3 sm:px-5 text-sm font-bold text-white bg-amber-400 hover:bg-amber-500 rounded-r-xl shadow-sm transition-colors whitespace-nowrap shrink-0"
              >
                ค้นหา
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto h-[950px] relative custom-scrollbar">
      <table
        class="w-full text-left border-collapse"
        [class.opacity-50]="isLoading"
        [class.pointer-events-none]="isLoading"
      >
        <thead
          class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm"
        >
          <tr>
            <th
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center w-14 whitespace-nowrap"
            >
              #
            </th>
            <th
              (click)="sortData('cardName')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                หมายเลขบัตร
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'cardName'"
                  >{{
                    sortColumn === "cardName" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('name')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                ชื่อลูกค้า / ประเภทสิทธิ์ / บัตรสมาชิก
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'name'"
                  >{{
                    sortColumn === "name" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('vehicleTypeName')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                ประเภทรถ
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'vehicleTypeName'"
                  >{{
                    sortColumn === "vehicleTypeName" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('license')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                ทะเบียนรถ
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'license'"
                  >{{
                    sortColumn === "license" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('expireDate')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                หมดอายุ / ออกเมื่อ
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="
                    sortColumn === 'issueDate' || sortColumn === 'expireDate'
                  "
                  >{{
                    (sortColumn === "issueDate" ||
                      sortColumn === "expireDate") &&
                    sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('writedate')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group text-center whitespace-nowrap"
            >
              <div class="flex items-center justify-center gap-1">
                สถานะ / วันที่ยกเลิก
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'writedate'"
                >
                  {{
                    sortColumn === "writedate" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}
                </span>
              </div>
            </th>

            <th
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center whitespace-nowrap"
            >
              รายละเอียด
            </th>
          </tr>
        </thead>

        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngIf="!selectedSiteId && !isLoading">
            <td [attr.colspan]="8" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center">
                <div
                  class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3"
                >
                  <span
                    class="material-icons text-3xl text-slate-300 dark:text-slate-600"
                    >location_off</span
                  >
                </div>
                <h3 class="text-slate-800 dark:text-slate-200 font-bold">
                  กรุณาเลือกลานจาก Sidebar
                </h3>
              </div>
            </td>
          </tr>

          <tr
            *ngFor="let c of rows; let i = index; trackBy: trackByCardId"
            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200"
            [ngStyle]="{ 'animation-delay': i * 0.03 + 's' }"
          >
            <td
              class="p-4 text-center text-sm font-bold text-slate-400 dark:text-slate-500 whitespace-nowrap"
            >
              {{ getRowNumber(i) }}
            </td>

            <td class="p-4 whitespace-nowrap">
              <div class="flex flex-col gap-0.5 min-w-0">
                <span class="text-xs text-slate-500 dark:text-slate-400 truncate">{{
                  c.cardName || "—"
                }}</span>
                <span
                  class="text-[11px] font-mono text-slate-400 dark:text-slate-500 truncate max-w-[14rem]"
                  [title]="c.cardCode || ''"
                  >{{ c.cardCode || "—" }}</span
                >
              </div>
            </td>

            <td class="p-4 whitespace-nowrap">
              <div class="flex flex-col gap-0.5">
                <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{
                  c.name || "-"
                }}</span>
                <span class="text-xs text-slate-400 dark:text-slate-500">{{
                  c.cardTypeName || "-"
                }}</span>
                <span
                  class="inline-flex w-fit mt-0.5 px-2 py-0.5 rounded-md text-[10px] font-bold bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 border border-amber-200/60 dark:border-amber-800/50"
                  [title]="'ประเภทบัตรสมาชิก'"
                  >{{ c.subscriptionName || "—" }}</span
                >
              </div>
            </td>

            <td class="p-4 whitespace-nowrap">
              <span
                class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300"
              >
                {{ c.vehicleTypeName || "—" }}
              </span>
            </td>

            <td class="p-4 whitespace-nowrap">
              <div class="flex items-center gap-1.5">
                <span
                  class="material-icons text-[16px]"
                  [ngClass]="hasPlate(c) ? 'text-emerald-500' : 'text-slate-300'"
                  [title]="c.vehicleTypeName || 'รถยนต์'"
                  >{{ getVehicleIcon(c.vehicleTypeName) }}</span
                >
                <span
                  class="text-sm font-bold font-mono"
                  [ngClass]="
                    hasPlate(c)
                      ? 'text-slate-700 dark:text-slate-200'
                      : 'text-slate-400'
                  "
                >
                  {{ getPlateDisplay(c) }}
                </span>
              </div>
            </td>

            <td class="p-4 whitespace-nowrap">
              <div class="flex flex-col gap-0.5">
                <span class="text-sm font-medium text-slate-700 dark:text-slate-200">
                  <span
                    class="text-[10px] font-bold text-slate-400 uppercase tracking-wide mr-1"
                    >หมด</span
                  >
                  {{ c.expireDate | date: "dd/MM/yyyy HH:mm" }}
                </span>
                <span class="text-xs text-slate-400 dark:text-slate-500">
                  <span
                    class="text-[10px] font-bold uppercase tracking-wide mr-1"
                    >ออก</span
                  >
                  {{ c.issueDate | date: "dd/MM/yyyy HH:mm" }}
                </span>
              </div>
            </td>

            <td class="p-4 text-center whitespace-nowrap">
              <div class="flex flex-col items-center gap-1.5">
                <span
                  class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400 border-rose-200 dark:border-rose-800"
                >
                  <span class="w-1.5 h-1.5 rounded-full mr-1.5 bg-rose-500"></span>
                  ยกเลิก
                </span>
                <span class="text-[11px] font-semibold text-slate-400 dark:text-slate-500">
                  {{ c.writeDate | date: "dd/MM/yyyy HH:mm" }}
                </span>
              </div>
            </td>

            <td class="p-4 text-center whitespace-nowrap relative z-10">
              <button
                type="button"
                (click)="openRemarkDetail(c)"
                class="inline-flex items-center justify-center w-9 h-9 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-300 hover:text-amber-500 dark:hover:text-amber-400 hover:border-amber-300 dark:hover:border-amber-600 hover:shadow-md transition-all active:scale-95"
                title="ดูรายละเอียดการยกเลิก"
              >
                <span class="material-icons text-[18px]">visibility</span>
              </button>
            </td>
          </tr>

          <tr *ngIf="selectedSiteId && !isLoading && rows.length === 0">
            <td [attr.colspan]="8" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center">
                <div
                  class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3"
                >
                  <span
                    class="material-icons text-3xl text-slate-300 dark:text-slate-600"
                    >search_off</span
                  >
                </div>
                <h3 class="text-slate-800 dark:text-slate-200 font-bold">
                  ไม่พบข้อมูล
                </h3>
                <span class="text-slate-400 dark:text-slate-500 text-sm mt-1"
                  >ลองปรับการค้นหาใหม่อีกครั้ง</span
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="p-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4"
    >
      <div
        class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 w-full"
      >
        <div
          class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium"
        >
          <span
            >แสดง {{ startItemIndex | number }} -
            {{ endItemIndex | number }} จาก
            {{ totalItems | number }} รายการ</span
          >
          <select
            (change)="onPageSizeChange($event)"
            [(ngModel)]="pageSize"
            class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-500/30 focus:border-amber-400 dark:focus:border-amber-600 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 transition-colors"
          >
            <option *ngFor="let size of pageSizeOptions" [value]="size">
              {{ size }} / หน้า
            </option>
          </select>
        </div>

        <div class="flex items-center gap-2">
          <button
            type="button"
            (click)="setPage(currentPage - 1)"
            [disabled]="currentPage === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400"
          >
            <span class="material-icons text-sm">chevron_left</span>
          </button>

          <button
            type="button"
            *ngFor="let page of pagesArray"
            (click)="setPage(page)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
            [ngClass]="
              page === currentPage
                ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none'
                : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 dark:hover:text-amber-400'
            "
          >
            {{ page }}
          </button>

          <button
            type="button"
            (click)="setPage(currentPage + 1)"
            [disabled]="currentPage === totalPages || totalPages === 0"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400"
          >
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Remark detail modal -->
<div
  *ngIf="isRemarkModalOpen"
  class="fixed inset-0 z-[9999] flex items-center justify-center p-4"
>
  <div
    class="absolute inset-0 bg-slate-950/60 backdrop-blur-md animate-fade-in"
    (click)="closeRemarkDetail()"
  ></div>
  <div
    class="relative bg-white dark:bg-slate-900 rounded-[28px] shadow-2xl w-full max-w-md p-6 sm:p-8 text-left animate-scale-up border border-white/20 dark:border-slate-800/50"
  >
    <div class="flex items-start justify-between gap-3 mb-5">
      <div class="min-w-0">
        <div class="flex items-center gap-2 mb-1">
          <span class="material-icons text-rose-500 text-[22px]">info</span>
          <h3 class="text-lg font-black text-slate-800 dark:text-white tracking-tight">
            รายละเอียดการยกเลิก
          </h3>
        </div>
        <p class="text-sm font-bold text-slate-500 dark:text-slate-400 truncate">
          {{ remarkModalTitle }}
        </p>
      </div>
      <button
        type="button"
        (click)="closeRemarkDetail()"
        class="shrink-0 w-9 h-9 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all flex items-center justify-center"
        title="ปิด"
      >
        <span class="material-icons text-[18px]">close</span>
      </button>
    </div>

    <div class="space-y-3 mb-6">
      <div class="flex items-center justify-between gap-3 text-xs font-semibold text-slate-400 dark:text-slate-500">
        <span>วันที่ยกเลิก</span>
        <span class="tabular-nums text-slate-600 dark:text-slate-300">
          {{ remarkModalCard?.writeDate | date: 'dd/MM/yyyy HH:mm' }}
        </span>
      </div>
      <div
        class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80 p-4 min-h-[100px]"
      >
        <p class="text-[11px] font-bold uppercase tracking-wide text-slate-400 dark:text-slate-500 mb-2">
          Remark
        </p>
        <p
          class="text-sm leading-relaxed whitespace-pre-wrap break-words"
          [ngClass]="
            remarkModalCard?.remark?.trim()
              ? 'text-slate-700 dark:text-slate-200 font-medium'
              : 'text-slate-400 dark:text-slate-500 italic'
          "
        >
          {{ remarkModalCard?.remark?.trim() || 'ไม่มีหมายเหตุการยกเลิก' }}
        </p>
      </div>
    </div>

    <button
      type="button"
      (click)="closeRemarkDetail()"
      class="w-full py-3 text-sm font-bold text-white bg-amber-400 hover:bg-amber-500 rounded-xl shadow-lg shadow-amber-200/40 dark:shadow-none transition-all active:scale-[0.98]"
    >
      ปิด
    </button>
  </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
